import { LoginScreen, type LoginResult, type LoginScreenEndpoints } from '@cca/ui';

// The Finance Portal door adopts the estate's ONE sign-in screen (ADR-018 /
// AUTH-8): the shared @cca/ui <LoginScreen> replaces finance's bespoke
// passkey-first + OTP login (the two hand-built "Sign In" + "Enter code" views).
// The session is BEARER — onSignedIn reads result.token + result.role into
// localStorage exactly as the old handler did, then enters the app. Terracotta
// #7E4725 is finance's signature colour, and the SAME accent the OTP email uses
// (renderOtpCodeEmail / email.ts), so the screen and the login-code email match
// (UX-1). The button/input classes come from @cca/ui/components + the role tokens
// from @cca/ui/tokens (both already imported in main.tsx); the accent is a prop.

// Finance's auth endpoints (paths unchanged for passkeys; OTP now the shared
// factory's /api/auth/otp/{request,verify} — see cca-xero-worker routes/auth.ts).
const FINANCE_ENDPOINTS: LoginScreenEndpoints = {
  discoverOptions: '/api/auth/passkeys/discover-options',
  discoverVerify: '/api/auth/passkeys/discover-verify',
  passkeyOptions: '/api/auth/passkeys/options',
  passkeyVerify: '/api/auth/passkeys/verify',
  otpRequest: '/api/auth/otp/request',
  otpVerify: '/api/auth/otp/verify',
};

interface Props {
  onAuthenticated: () => void;
}

export function FinanceSignIn({ onAuthenticated }: Props) {
  /** Store the minted Bearer session and enter the app (unchanged behaviour). */
  const applySession = (result: LoginResult) => {
    if (!result.token) return;
    localStorage.setItem('xero_session_token', result.token);
    localStorage.setItem('xero_session_role', result.role ?? 'viewer');
    onAuthenticated();
  };

  return (
    <LoginScreen
      portalName="Finance Portal"
      accentColor="#7E4725"
      endpoints={FINANCE_ENDPOINTS}
      onSignedIn={applySession}
      authzDeniedCopy="You are not authorised to access the Finance Portal. Contact registrar@confessinganglicans.nz if you believe this is an error."
    />
  );
}
